import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { fetchCustomerGroup, updateCustomerGroup } from "../../actions/customer-groups.actions";

import { getResourceById } from "../../reducers/resources.reducer";
import CustomerGroupForm from "./CustomerGroupForm";
export class EditCustomerGroup extends PureComponent {
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.dispatch(fetchCustomerGroup(id));
  }

  saveCustomerGroupChanges = customerGroup => {
    const { id } = customerGroup;
    this.props.dispatch(updateCustomerGroup(id, { customerGroup }));
  };

  render() {
    const { customerGroup } = this.props;

    return (
      <CustomerGroupForm
        page={"Edit"}
        customerGroup={customerGroup}
        saveCustomerGroupChanges={this.saveCustomerGroupChanges}
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { id } = props.match.params;

  return {
    customerGroup: getResourceById(state, id)
  };
};
export default connect(mapStateToProps)(EditCustomerGroup);
